import { useEffect, useState, useRef } from "react";
import {
  currentTabHandler,
  customFetchImages,
  getGalleryImages,
  setImagesLoading,
  updateSuggestedImageCount,
  uploadModalAction,
} from "../store/slices/Gallery/gallerySlice";

import { uploadFPAModalAction } from "../store/slices/Gallery/galleryFPAupload";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  openPreSelectionhandler,
  updateImageCountGallery,
  openDeleteImagesPopup,
  deSelectSingleImage,
  deleteActionSuccess,
  deleteGalleryImages,
  closeFilterActions,
  orderChangeGallery,
  unSelectAllImages,
  selectSingleImage,
  getFolderDetails,
  selectAllImages,
  closePreSelect,
} from "../store/slices/Gallery/gallerySlice";
import {
  changeSortOrder,
  getCurrentPageDetails,
  getFolderDetailsByID,
  getFoldersByProjectID,
} from "../store/slices/Project/ProjectSingle";

export const useGalleryTab = () => {
  const selectedElement = useRef();
  const suggestedElement = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { projectID, folderID } = useParams();
  const [activeTab, setActiveTab] = useState(
    window.location.pathname.indexOf("selected") != -1
      ? "selected"
      : window.location.pathname.indexOf("suggested") != -1
      ? "suggested"
      : "all"
  );
  const [isChecked, setIsChecked] = useState(false);
  const [activeTabLeft, setActiveTabLeft] = useState("");
  const [activeTabWidth, setActiveTabWidth] = useState("");
  const [isNavigating, setIsNavigating] = useState(false);
  const { currentFolderDetails, sections, currentTab, status } = useSelector(
    (state) => state.gallery
  );
  const { getCurrentProjectDetails } = useSelector(
    (state) => state.projectSinglePage
  );
  const { currentPageDetails } = getCurrentProjectDetails;
  const { singleFolderData } = useSelector((state) => state.projectSinglePage);

  const selectedImageIds = sections[currentTab]?.selectedImages?.map(
    (item) => item
  );
  const suggestedDataIds = sections["suggested"]?.data?.map((data) => data?.id);

  const filteredSelectedImages = selectedImageIds?.filter((item) =>
    suggestedDataIds?.includes(item)
  );
  // const handleClickTab = async (e, tab) => {
  //   setActiveTab(tab);
  //   setActiveTabLeft(e.target.offsetLeft);
  //   setActiveTabPos(e.target.offsetLeft);
  //   setActiveTabWidth(e.target.offsetWidth);
  //   if (tab === "all") {
  //     navigate(`${projectID}/folders/${folderID}`);
  //   } else if (tab === "selected") {
  //     navigate(`${projectID}/folders/${folderID}/selected`);
  //   } else if (tab === "suggested") {
  //     navigate(`${projectID}/folders/${folderID}/suggested`);
  //   }
  //   await dispatch(currentTabHandler(tab));
  // };
  const handleClickTab = async (e, tab) => {
    setActiveTab(tab);
    setIsNavigating(false);
    setActiveTabLeft(e.target.offsetLeft);
    setActiveTabWidth(e.target.offsetWidth);
    dispatch(setImagesLoading(false));

    let targetURL = `${projectID}/folders/${folderID}`;
    switch (tab) {
      case "all":
        targetURL = `${targetURL}`;
        break;
      case "selected":
        targetURL = `${targetURL}/selected`;
        break;
      case "suggested":
        targetURL = `${targetURL}/suggested`;
        break;
      default:
        break;
    }
    navigate(targetURL);

    dispatch(currentTabHandler(tab));
  };

  useEffect(() => {
    handleGetFolderDetails();
    //eslint-disable-next-line
  }, []);

  const handleGetFolderDetails = () => {
    let obj = {
      id: Number(folderID),
      url: "/album/get-album",
    };
    // dispatch(getFolderDetails(obj));
    dispatch(getFolderDetailsByID(obj));
    const data = {
      id: projectID,
    };
    dispatch(getCurrentPageDetails(data));
  };

  // useEffect(() => {
  //   if (status === "succeeded") {
  //     if (window.location.pathname.indexOf("selected") != -1) {
  //       setTimeout(() => {
  //         setActiveTab("selected");
  //         selectedElement.current.click();
  //       }, 400);
  //     }
  //     if (window.location.pathname.indexOf("suggested") != -1) {
  //       setTimeout(() => {
  //         setActiveTab("suggested");
  //         suggestedElement.current.click();
  //       }, 400);
  //     }
  //   }
  // }, [status]);

  useEffect(() => {
    let activeTabSelect = document.querySelectorAll(".tabActive");
    setActiveTabLeft(activeTabSelect[0]?.offsetLeft);
    setActiveTabWidth(activeTabSelect[0]?.offsetWidth);
  }, []);

  const switchActiveTab = (e, tab) => {
    setActiveTab(tab);
    setActiveTabLeft(e.target.offsetLeft);
    setActiveTabWidth(e.target.offsetWidth);
  };

  const handlePreSelection = () => {
    dispatch(openPreSelectionhandler());
  };

  const handleclosePreSelect = () => {
    dispatch(closePreSelect());
    dispatch(unSelectAllImages());
  };

  const handleSelectAllImages = () => {
    let imagesIDs = sections[currentTab]?.data.map((item) => item.id);
    dispatch(selectAllImages(imagesIDs));
  };

  const handledeSelectAllImages = () => {
    dispatch(unSelectAllImages());
  };

  const uploadModal = (data) => {
    dispatch(uploadModalAction(data));
  };

  const uploadFPAModal = (data) => {
    dispatch(uploadFPAModalAction(data));
  };

  const handleSelectImage = (ImageID) => {
    if (
      sections[currentTab]?.selectedImages?.includes(ImageID) === false ||
      sections[currentTab]?.selectedImages == undefined
    ) {
      let previouslySelectedItems =
        sections[currentTab]?.selectedImages === undefined
          ? []
          : sections[currentTab]?.selectedImages;

      dispatch(selectSingleImage([...previouslySelectedItems, ...[ImageID]]));
    } else {
      /*************************************
       * REMOVEING DE-SELETED ITEM FROM ARRAY *
       *************************************/
      let newArrayIds = sections[currentTab]?.selectedImages?.filter((item) => {
        return item !== ImageID;
      });
      dispatch(deSelectSingleImage(newArrayIds));
    }
  };

  const handleDeleteSelectedImages = () => {
    let formdata = new FormData();
    let count = 0;
    if (sections[currentTab]?.selectedImages?.length > 0) {
      sections[currentTab]?.selectedImages?.forEach((ImageID) => {
        count++;
        formdata.append("image_id[]", ImageID);
      });
    }

    if (
      sections[currentTab]?.selectedImages?.length ===
      sections[currentTab]?.data?.length
    ) {
      formdata.append("action", "all");
    }

    formdata.append("album_id", folderID);

    let obj = {
      formdata: formdata,
      url: "/album/delete-image",
    };

    dispatch(deleteGalleryImages(obj))
      .unwrap()
      .then((res) => {
        if (res.data.success === true) {
          let updatedGallery = sections[currentTab]["data"]?.filter((items) => {
            return !sections[currentTab]?.selectedImages.includes(items.id);
          });
          dispatch(
            updateImageCountGallery(
              parseInt(currentFolderDetails.images_count) -
                sections[currentTab]?.selectedImages?.length
            )
          );

          dispatch(
            updateSuggestedImageCount(
              parseInt(currentFolderDetails.suggested_images_count) -
                filteredSelectedImages?.length
            )
          );
          dispatch(deleteActionSuccess(updatedGallery));
          toast.success(
            `${
              sections[currentTab]?.selectedImages?.length > 1
                ? "Images"
                : "Image"
            } Deleted!`,
            {
              position: "bottom-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );
        }
        let obj = {
          id: singleFolderData?.id,
          url: "/album/get-album",
        };
        // dispatch(getFolderDetails(obj));
      });
  };

  const handlePaymentPage = () => {
    if (
      Number.isInteger(parseInt(currentPageDetails?.client_id)) &&
      Number.isInteger(parseInt(projectID))
    ) {
      navigate(
        `/dashboard/user-plans/${projectID}/${currentPageDetails?.client_id}/`
      );
    } else {
      toast.error("Please add client details to complete the payment!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        pauseOnHover: false,
        progress: undefined,
        closeOnClick: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  const openDeletePopup = (state) => {
    dispatch(openDeleteImagesPopup(state));
  };

  const handleOrderChange = (order) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    dispatch(orderChangeGallery(order));
    const obj = {
      url: "/album/album-images",
      id: folderID,
      page: 1,
      sort: order,
      per_page: 20,
    };
    getAlbumsItems(obj);
  };

  const getAlbumsItems = async (obj) => {
    const resultAction = await dispatch(getGalleryImages(obj));
    dispatch(setImagesLoading(true));
    if (getGalleryImages.fulfilled.match(resultAction)) {
      loadMoreData(resultAction?.payload?.data?.result, obj);
    }
  };
  const { currentSortOrder } = useSelector((state) => state.projectSinglePage);

  const loadMoreData = async (Albums, data) => {
    if (Albums?.current_page < Albums.last_page) {
      const obj = {
        url: "/album/album-images",
        id: folderID,
        page: Albums?.current_page + 1,
        sort: currentSortOrder,
        per_page: 20,
      };
      if (currentTab === "all") {
        const resultAction = await dispatch(customFetchImages(obj));
        if (customFetchImages.fulfilled.match(resultAction)) {
          loadMoreData(resultAction?.payload?.data?.result);
        }
      }
    } else if (Albums?.current_page == Albums.last_page) {
      dispatch(setImagesLoading(false));
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (typeof string !== "string") {
      return false;
    }
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  };

  return {
    handleClickTab,
    activeTab,
    setActiveTab,
    isChecked,
    setIsChecked,
    activeTabLeft,
    setActiveTabLeft,
    activeTabWidth,
    setActiveTabWidth,
    switchActiveTab,
    selectedElement,
    suggestedElement,
    currentFolderDetails,
    handlePreSelection,
    handleclosePreSelect,
    handleSelectAllImages,
    handledeSelectAllImages,
    uploadModal,
    uploadFPAModal,
    handleSelectImage,
    handleDeleteSelectedImages,
    openDeletePopup,
    handleOrderChange,
    capitalizeFirstLetter,
    handlePaymentPage,
    isNavigating,
  };
};
